<template>
  <th
    scope="col"
    :class="{
      'validation-cell': !hiddenColumns[columnId],
      'hidden-validation-cell': hiddenColumns[columnId],
      'datatable-row-header': isStick
    }"
    :style="{ left: left }"
  >
    <div class="validation-content" :style="validationStyle">
      <div class="flexrow">
        <department-name
          class="department-dot flexrow-item"
          :department="currentDepartment"
          :only-dot="false"
          :size="6"
          :style="{ padding: '0px 0px', 'font-size': '7pt' }"
          v-if="currentDepartment"
        />
        <chevron-left-icon
          @click="$emit('move-left', $event)"
          class="header-icon flexrow-item left-arrow"
        />
        <chevron-right-icon
          @click="$emit('move-right', $event)"
          class="header-icon flexrow-item right-arrow"
        />
      </div>
      <div class="flexrow">
        <router-link
          class="flexrow-item datatable-dropdown task-type-name"
          style="margin-right: 0"
          :to="taskTypePath(columnId)"
          v-if="!isCurrentUserClient"
        >
          {{ !hiddenColumns[columnId] ? taskTypeMap.get(columnId).name : '' }}
        </router-link>
        <span
          class="flexrow-item datatable-dropdown task-type-name"
          style="margin-right: 0"
          v-else
        >
          {{ !hiddenColumns[columnId] ? taskTypeMap.get(columnId).name : '' }}
        </span>

        <chevron-down-icon
          @click="$emit('show-header-menu', $event)"
          class="header-icon flexrow-item down-arrow"
        />
      </div>
    </div>
  </th>
</template>

<script>
import {
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from 'vue-feather-icons'
import { mapGetters } from 'vuex'
import { getTaskTypePriorityOfProd } from '@/lib/productions'
import DepartmentName from '@/components/widgets/DepartmentName'

export default {
  name: 'ValidationHeader',
  props: {
    hiddenColumns: Object,
    columnId: String,
    validationStyle: Object,
    isStick: {
      type: Boolean,
      default: false
    },
    left: {
      type: String,
      default: '0px'
    },
    type: {
      type: String,
      default: 'assets'
    }
  },
  components: {
    ChevronDownIcon,
    DepartmentName,
    ChevronLeftIcon,
    ChevronRightIcon,
  },
  computed: {
    ...mapGetters([
      'currentEpisode',
      'currentProduction',
      'isCurrentUserClient',
      'isTVShow',
      'departmentMap',
      'taskTypeMap'
    ]),

    currentDepartment() {
      return this.departmentMap.get(
        this.taskTypeMap.get(this.columnId).department_id
      )
    }
  },
  methods: {
    getPrio(column) {
      return getTaskTypePriorityOfProd(column, this.currentProduction)
    },

    taskTypePath(taskTypeId) {
      const taskType = this.taskTypeMap.get(taskTypeId)
      let route = {}
      if (taskType.for_entity === 'Episode') {
        route = {
          name: 'episodes-task-type',
          params: {
            production_id: this.currentProduction.id,
            task_type_id: taskTypeId
          }
        }
      } else {
        route = {
          name: 'task-type',
          params: {
            production_id: this.currentProduction.id,
            task_type_id: taskTypeId,
            type: this.type
          }
        }

        if (this.isTVShow && this.currentEpisode) {
          route.name = 'episode-task-type'
          route.params.episode_id = this.currentEpisode.id
        }
      }

      return route
    }
  }
}
</script>

<style lang="scss" scoped>
th.metadata-descriptor {
  min-width: 120px;
  max-width: 120px;
  width: 120px;
  overflow-wrap: break-word;
  hyphens: auto;
}

.task-type-name {
  font-size: 1.1em;
  max-width: 95%;
  text-transform: none;
  overflow: hidden;
}

.department-dot {
  width: 100%;
  margin: 0;
  overflow: hidden;
}

.header-icon {
  background: var(--background);
  height: 18px;
  padding: 1px;
  margin: 0;
}

.left-arrow {
  border-radius: 50% 0 0 50%;
}
.right-arrow {
  border-radius: 0 50% 50% 0;
}
.down-arrow {
  border-radius: 50%;
}

.validation-content {
  padding: 2px 2px 2px 10px;
}
</style>
